// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"33fa70a7","453":"3398875d","627":"63740484"}[chunkId] + ".chunk.js";
};